module.exports = __webpack_public_path__ + "static/media/GL.b4990444.svg";